import storage from 'redux-persist/lib/storage';
import hardSet from 'redux-persist/lib/stateReconciler/hardSet';
import { encryptTransform } from 'redux-persist-transform-encrypt';

const persistConfig = {
	key: 'eas-emd-f',
	storage,
	transforms: [
		encryptTransform({
			secretKey: 'rT2FZ5y8f6',
			onError: (error) => {
				// eslint-disable-next-line no-console
				console.log('Encrypt Transform Error', error);
			},
		}),
	],
	whitelist: ['auth', 'user'],
};
export { persistConfig };
